export default {
  Analyze: {
    Revenue: {
      Revenue: 'مبلغ درآمد از فروش',
      MAU: 'کاربران فعال',
      MAU_Description: 'کاربرانی که حداقل یک تراکنش فعال دارند.',
      ARPU: 'میانگین درآمد به ازای هر کاربر',
    },
    PaymentsAndUsers: {
      Title: 'گزارش پرداختی‌ها و کاربران',
      Payments: {
        Success: 'پرداخت‌های موفق',
        UnSuccess: 'پرداخت‌های ناموفق',
        Without: 'کاربران بدون پرداخت',
      },
      All: 'تعداد کاربران',
    },
    ForNewUsers: 'کاربران جدید',
  },
}
